import React from 'react';

import AddressLookupField from 'views/AddressLookupField.js';
import Appearance from 'styles/Appearance.js';
import BoolToggle from 'views/BoolToggle.js';
import ClientLookupField from 'views/ClientLookupField.js';
import ColorPickerField from 'views/ColorPickerField.js';
import DateDurationPickerField from 'views/DateDurationPickerField.js';
import DatePickerDropdownField from 'views/DatePickerDropdownField.js';
import DualDatePickerField from 'views/DualDatePickerField.js';
import DurationPickerField from 'views/DurationPickerField.js';
import FilePickerField from 'views/FilePickerField.js';
import IconPickerField from 'views/IconPickerField.js';
import ImagePickerField from 'views/ImagePickerField.js';
import { LayerItem } from 'structure/Layer.js';
import LeadScriptEditor from 'views/LeadScriptEditor.js';
import LeadScriptPickerField from 'views/LeadScriptPickerField.js';
import LeadSubTypePickerField from 'views/LeadSubTypePickerField.js';
import LeadTypePickerField from 'views/LeadTypePickerField.js';
import ListField from 'views/ListField.js';
import LocationRadiusLookupField from 'views/LocationRadiusLookupField.js';
import MultipleListField from 'views/MultipleListField.js';
import TagLookupField from 'views/TagLookupField.js';
import TextField from 'views/TextField.js';
import TimePicker from 'views/TimePicker.js';
import TimezoneLookupField from 'views/TimezoneLookupField.js';
import TimeRangePicker from 'views/TimeRangePicker.js';
import UserLookupField from 'views/UserLookupField.js';

export const AltFieldItemSpacing = 24;

export const validateRequiredFields = async get => {
    return new Promise((resolve, reject) => {
        let items = get().reduce((array, field) => {
            return array.concat(field.items);
        }, []);
        let required = items.find(item => {
            if(item.required === false) {
                return false;
            }
            return item.value === null || item.value === undefined;
        });
        if(required) {
            let error = new Error(`One or more required fields are incomplete. Please fill out the "${required.title.toLowerCase()}" before moving on`);
            reject(error);
            return;
        }
        resolve();
    })
}

export const AltFieldItem = ({ connect = false, item, lastItem = true, utils }) => {

    const onComponentClick = item => {
        switch(item.component) {
            case 'lead_script_editor':
            utils.layer.open({
                id: 'lead_script_editor',
                Component: LeadScriptEditor.bind(this, {
                    utils: utils,
                    ...item
                })
            });
            break;
        }
    }
    
    const onSupportClick = () => {
        utils.alert.show({
            title: item.title,
            message: item.description
        });
    }

    const getComponent = item => {

        let { component, icon, items, loading, onChange, onClick, onValidate, props = {}, value } = item;
        switch(component) {
            case 'address_lookup':
            return (
                <AddressLookupField
                icon={icon}
                loading={loading}
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'bool_list':
            return (
                <ListField
                items={[{
                    id: 'yes',
                    title: 'Yes'
                },{
                    id: 'no',
                    title: 'No'
                }]}
                onChange={item => onChange(item ? item.id === 'yes' : null)}
                utils={utils}
                value={typeof(value) === 'boolean' ? (value ? 'Yes' : 'No') : null}
                {...props} />
            );

            case 'bool_toggle':
            return (
                <BoolToggle
                enabled={'Yes'}
                disabled={'No'}
                isEnabled={value}
                onChange={onChange}
                {...props}
                style={{
                    margin: null
                }} />
            );

            case 'color_picker':
            return (
                <ColorPickerField
                onChange={onChange}
                value={value}
                {...props} />
            )

            case 'client_lookup':
            return (
                <ClientLookupField
                icon={icon}
                loading={loading}
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'date_duration_picker':
            return (
                <DateDurationPickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'date_picker_dropdown':
            return (
                <DatePickerDropdownField
                onChange={onChange}
                value={value}
                {...props} />
            )

            case 'dual_date_picker':
            return (
                <DualDatePickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'duration_picker':
            return (
                <DurationPickerField
                onChange={onChange}
                style={{
                    width: '100%'
                }}
                {...props} />
            )

            case 'file_picker':
            return (
                <FilePickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'icon_picker':
            return (
                <IconPickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'image_picker':
            return (
                <ImagePickerField
                utils={utils}
                value={value}
                onChange={onChange}
                {...props} />
            )

            case 'lead_script_editor':
            return (
                <div
                className={`dummy-field ${window.theme} text-button`}
                onClick={onComponentClick.bind(this, item)}
                style={{
                    width: '100%',
                    height: 35
                }}>
                    <span style={{
                        flexGrow: 1,
                        borderWidth: 0,
                        fontSize: 12,
                        fontWeight: 500,
                        color: value ? Appearance.colors.text() : Appearance.colors.subText(),
                        backgroundColor: Appearance.colors.transparent,
                    }}>{value ? 'Click to make changes...' : (props && props.placeholder ? props.placeholder : 'No script content added...')}</span>
                </div>
            )

            case 'lead_script_picker':
            return (
                <LeadScriptPickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'lead_sub_type_picker':
            return (
                <LeadSubTypePickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'lead_type_picker':
            return (
                <LeadTypePickerField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'list':
            return (
                <ListField
                items={items}
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'location_radius_lookup':
            return (
                <LocationRadiusLookupField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'multiple_list':
            return (
                <MultipleListField
                items={items}
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'tag_lookup':
            return (
                <TagLookupField
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'textfield':
            return (
                <TextField
                icon={icon}
                value={value}
                loading={loading}
                onValidate={onValidate}
                onChange={onChange}
                onClick={onClick}
                {...props} />
            )

            case 'textview':
            return (
                <TextField
                icon={icon}
                value={value}
                loading={loading}
                expandWithText={true}
                onValidate={onValidate}
                onChange={onChange}
                {...props} />
            )

            case 'time_picker':
            return (
                <TimePicker
                onChange={onChange}
                utils={utils}
                value={value}
                {...props} />
            )

            case 'time_range_picker': 
            return (
                <TimeRangePicker
                onChange={onChange}
                value={value}
                {...props} />
            )

            case 'timezone_lookup':
            return (
                <TimezoneLookupField
                onChange={onChange}
                utils={utils}
                value={value}
                style={{
                    width: '100%'
                }}
                {...props} />
            )

            case 'user_lookup':
            return (
                <UserLookupField
                icon={icon}
                utils={utils}
                value={value}
                loading={loading}
                placeholder={'Search by first or last name...'}
                onChange={onChange}
                {...props} />
            )

            default:
            return null;
        }
    }
    
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: lastItem === false ? AltFieldItemSpacing : 0,
            minWidth: 0,
            width: '100%',
        }}>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                minWidth: 0
            }}>
                {item.required !== false && (item.value === null || item.value === undefined) && (
                    <div style={{
                        backgroundColor: Appearance.colors.red,
                        borderRadius: 2.5,
                        height: 5,
                        overflow: 'hidden',
                        marginRight: 8,
                        width: 5
                    }} />
                )}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: 4
                }}>
                    <span style={{
                        ...Appearance.textStyles.subHeader()
                    }}>{connect === true ? (item.connect_title || item.title) : item.title}</span>
                    {typeof(item.subTitle) === 'string' && (
                        <span style={{
                            ...Appearance.textStyles.subTitle()
                        }}>{item.subTitle}</span>
                    )}
                </div>
            </div>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                position: 'relative',
                width: '100%'
            }}>
                {getComponent(item)}
                {item.description && connect === false && (
                    <img
                    className={'text-button'}
                    src={window.theme === 'dark' ? 'images/help-badge-dark.png' : 'images/help-badge-light.png'}
                    onClick={onSupportClick}
                    style={{
                        flex: 'none',
                        height: 30,
                        marginLeft: 8,
                        objectFit: 'contain',
                        width: 30
                    }} />
                )}
            </div>
        </div>
    )
}

const AltFieldMapper = ({ connect = false, fields, utils }) => {

    const getContent = () => {

        let sections = fields.filter(section => section.visible !== false);
        if(connect === true) {
            return (
                <div
                className={'row m-0 px-0 pt-2 pb-0'}>
                    {sections.map((section, index) => {
                        return section.items.filter(item => {
                            return item.visible !== false && item.connect !== false;
                        }).map((item, i, items) => {
                            return (
                                <div
                                key={i}
                                className={`col-12 col-xl-6 px-3 pt-0 ${index !== sections.length - 1 ? 'pb-2' : 'pb-0'}`}>
                                    <AltFieldItem 
                                    connect={connect}
                                    item={item}
                                    lastItem={index === items.length - 1}
                                    utils={utils} />
                                </div>
                            )
                        });
                    })}
                </div>
            )
        }

        return sections.map((section, index) => {
            return (
                <LayerItem
                collapsed={section.collapsed !== undefined ? section.collapsed : false}
                key={index}
                lastItem={typeof(section.lastItem) === 'boolean' ? section.lastItem : index === sections.length - 1}
                rightContent={section.rightContent}
                title={section.title}>
                    <div style={{
                        ...Appearance.styles.unstyledPanel(),
                        overflow: 'visible',
                        paddingBottom: 16,
                        paddingLeft: 16,
                        paddingRight: 16,
                        paddingTop: 12,
                        width: '100%'
                    }}>
                        {typeof(section.description) === 'string' && (
                            <span style={{
                                color: Appearance.colors.text(),
                                display: 'block',
                                fontWeight: 500,
                                fontSize: 14,
                                marginBottom: 16,
                                maxWidth: '100%',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'wrap',
                                width: '100%'
                            }}>
                                {section.description}
                            </span>
                        )}
                        {section.items && section.items.filter(item => {
                            return item.visible !== false;
                        }).map((item, index, items) => {
                            return (
                                <AltFieldItem 
                                connect={connect}
                                key={index} 
                                item={item}
                                lastItem={index === items.length - 1}
                                utils={utils} />
                            )
                        })}
                    </div>
                </LayerItem>
            )
        })
    }
    return getContent();
}

export default AltFieldMapper;
